import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next';
import { Breadcrumbs, UL } from '../../../../AbstractElements';
import AuditReconciliation from './AuditReconciliation';
import { Container } from 'reactstrap';

const Reconciliation = () => {
    const { t } = useTranslation();
    return (
        <UL attrUL={{ className: 'simple-list nav-menus flex-row' }}>
            <Fragment>
                <Breadcrumbs parent={t('Audit')} title={t('Audit Reconciliation')} mainTitle={t('Audit Reconciliation')} />
                <Container fluid={true}>
                    <AuditReconciliation />
                </Container>
            </Fragment>
        </UL>
    )
}

export default Reconciliation